import { Trans } from "react-i18next";

interface IRemoveDeviceInstructions {
    serialNumber:string;
    clinicName?:string;
}
const UnassignDeviceInstructions:React.FC<IRemoveDeviceInstructions> = ({serialNumber, clinicName}) => {
    return (
        <>
            <div className="mt-1">
                {/* `components` is passed explicitly so the line break after the
                    serial number cannot be dropped: without it the <br/> only
                    survives via react-i18next's default transKeepBasicHtmlNodesFor
                    allow-list, which any i18n config change could take away. */}
                <p style={{ textAlign: 'center', marginBottom:'0px', fontSize:'14px', fontWeight:'400' }}>
                    <Trans
                        i18nKey="UnassignDeviceInstruction"
                        values={{ serialNumber: serialNumber}}
                        components={{ strong: <strong />, br: <br /> }}
                    /></p>
                    
            </div>
        </>
    )
}
export default UnassignDeviceInstructions;